import Vue from 'vue'
import { formatDate, formatDateAndTime, detectAndFormatDate, detectAndFormatTypes, detectAndFormatOtherTypes } from './utils'

Vue.filter('formatDate', formatDate)
Vue.filter('formatDateAndTime', formatDateAndTime)
Vue.filter('detectAndFormatDate', detectAndFormatDate)
Vue.filter('detectAndFormatTypes', detectAndFormatTypes)
Vue.filter('detectAndFormatOtherTypes', detectAndFormatOtherTypes)
